import ComplexBreadcrumb from '@Components/Shared/ComplexBreadcrumb';
import TranslationText from '@Components/Utilities/TranslationText';
import BlogArticleCategories from '@Components/Blog/BlogArticleCategories';
import BlogArticleTags from '@Components/Blog/BlogArticleTags';
import BlogArticleArchiveMenu from '@Components/Blog/BlogArticleArchiveMenu';
import SEOLinks from '@Components/Listings/SEOLinks';
import ListingCarousel from '@Components/Shared/ListingCarousel';
import { useWindowSize } from '@Components/Utilities/WindowSize';
const EmailModal = loadable(() => import('@Components/Shared/Modals/EmailModal'), true);
const EmployeeArticleModal = loadable(() => import('@Components/Shared/Modals/EmployeeArticleModal'), true);
import { useState, useRef } from 'react';
import { loadable } from '@Components/Utilities/SandhillsLoadable';
import { inquiryType } from '@Components/Utilities/SandhillsConstants';
import ConditionalWrapper from '@Components/Utilities/ConditionalWrapper';
import translator from '@Components/Utilities/Translator';


const BlogDetailView = (props) => {
    const windowSize = useWindowSize();
    const [showEmailModal, setShowEmailModal] = useState(false);
    const [showEmployeeModal, setShowEmployeeModal] = useState(false);
    const [showShareButtons, setShowShareButtons] = useState(false);
    const [selectedInquiry, setSelectedInquiry] = useState('');
    const ref = useRef(null);
    const [samModel, setSamModel] = useState(props.SAMModel);

    const openEmailModal = (inquiry, modalData) => {
        modalData = modalData || {};
        modalData.ModalTitle = translator.translate('sandhillssystem.share').toString();
        if (windowSize.isMobile && navigator.share) {
            navigator.share({
                title: document.title,
                url: window.location.href
            })
                .then(() => gtmPushEvent(gtmEventType.MobileShare))
                .catch(() => setShowShareButtons(true));
            return;
        } else {
            setShowShareButtons(true);
        }

        setSelectedInquiry(inquiry);
        setShowEmailModal(showEmailModal => !showEmailModal);
        setSamModel(previousState => {
            return {
                ...previousState,
                ...modalData
            };
        });
    };

    const onEmailModalToggle = () => {
        if (ref.current) {
            ref.current.focus();
        }
        setShowEmailModal(showEmailModal => !showEmailModal);
    };

    const onEmployeeModalToggle = () => {
        setShowEmployeeModal(showEmployeeModal => !showEmployeeModal);
    };

    return (
        <div className='content-wrapper'>
            <div className={props.UseNewListPageDesign ? 'content-body list-redesign' : 'content-body'}>
                <ComplexBreadcrumb BreadCrumbModels={props.Breadcrumbs} LinkEndItem={true} />
                <div className='inner-wrap'>
                    <div itemScope itemType='https://schema.org/BlogPosting' className='article-content-wrapper left'>
                        {props.ShowEmailThis &&
                            <button type='button' id='blog-detail-share' className='email-this' ref={ref} onClick={() => openEmailModal(inquiryType.EmailThis)}>
                                <i className='fas fa-share-alt media-buttons__icon' />
                                <span className='visually-hidden'><TranslationText key='email-button' tKey='sandhillssystem.share' /></span>
                            </button>}
                        <h1 itemProp='headline' className='blog-detail-header'>{props.PageHeader}</h1>
                        <div class="blog-credits border-bottom">
                            {props.AuthorBylineFormatted && <div dangerouslySetInnerHTML={{ __html: props.AuthorBylineFormatted }} />}
                            <span className='visually-hidden' itemProp='datePublished' content={props.DisplayLastUpdate ? props.UpdatedDateFormatted : props.PostedDateFormatted} />
                            <ConditionalWrapper condition={props.UseSEOHTagReorganization} wrapper={children => <h3 className="header-reset">{children}</h3>}>
                                {props.DisplayLastUpdate ?
                                    <>
                                        <div className='blog-updated-date' dangerouslySetInnerHTML={{ __html: props.UpdatedOnDateFormatted }} />
                                        <div className='blog-posted-date' dangerouslySetInnerHTML={{ __html: props.OriginallyPostedOnDateFormatted }} />
                                    </> :
                                    <div className='blog-posted-date' dangerouslySetInnerHTML={{ __html: props.PostedOnDateFormatted }} />}
                            </ConditionalWrapper>
                            {props.ShowEmployeeOnlyInfo &&
                                <a className='view-article-details-link' onClick={onEmployeeModalToggle} tabIndex='0' role="button" onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onEmployeeModalToggle(); } }}>
                                    <strong><i className='fas fa-th-large' aria-hidden='true' /> &nbsp; <TranslationText tKey='sandhills.employeeonlydetails' /></strong>
                                </a>}
                        </div>
                        <div className='fluid'>
                            <div id='center_col' className='blog-col-center blog-detail-col-center columns'>
                                <div className='clear' />
                                <div className='column12'>
                                    <div itemProp='articleBody' className='blog-post-body' dangerouslySetInnerHTML={{ __html: props.MainBodyHTML }} />
                                </div>
                                <div className='column6 left cat-tags'>
                                    <ConditionalWrapper condition={props.UseSEOHTagReorganization} wrapper={children => <h3 className="header-reset">{children}</h3>}>
                                        <strong><TranslationText tKey='sandhills.category' />:</strong> <a className='link-bl' href={props.BlogCategoryUrl}>{props.ArticleCategory}</a><br />
                                    </ConditionalWrapper>
                                    {props.ArticleTagList && props.ArticleTagList.length > 0 && <strong><TranslationText tKey='sandhills.tags' />:&nbsp;</strong>}
                                    {props.ArticleTagList && props.ArticleTagList.length > 0 &&
                                        props.ArticleTagList.map((articleTag, index) =>
                                            articleTag.LinkText &&
                                            <ConditionalWrapper condition={props.UseSEOHTagReorganization} wrapper={children => <h3 className="header-reset">{children}</h3>}>
                                                    <a key={index} className='link-bl article-tag' href={articleTag.LinkUrl}>{articleTag.LinkText}</a>
                                            </ConditionalWrapper>
                                        )}
                                </div>
                            </div>
                            {!windowSize.isMobile &&
                                <div id='right_col' className='blog-col-right blog-detail-right-menu columns'>
                                    <BlogArticleCategories Categories={props.AllCategoryList} />
                                    {props.AllTagList && props.AllTagList.length > 0 && <BlogArticleTags Tags={props.AllTagList} />}
                                    <BlogArticleArchiveMenu ArchiveArticleList={props.ArchiveArticleList} />
                                </div>
                            }
                        </div>
                    </div>

                    <div className='blog-carousel-wrapper'>
                        <ListingCarousel {...props.RelatedListings} />
                    </div>

                    {(props.InternalLinkingModel?.InternalLinkGroups) &&
                        <div className='blog-internal-links'>
                            <SEOLinks {...props.InternalLinkingModel} LoadInternalLinksOnDemand={false} SearchURL={props.SearchBaseURL} />
                        </div>}

                    {windowSize.isMobile &&
                        <div>
                            <BlogArticleCategories Categories={props.AllCategoryList} />
                            {props.AllTagList && props.AllTagList.length > 0 && <BlogArticleTags Tags={props.AllTagList} />}
                            <BlogArticleArchiveMenu ArchiveArticleList={props.ArchiveArticleList} />
                        </div>
                    }

                    {showEmailModal &&
                        <EmailModal
                            {...samModel}
                            toggleEmailModal={onEmailModalToggle}
                            selectedInquiry={selectedInquiry}
                            ShowSocialShareButtons={showShareButtons}
                        />}

                    {showEmployeeModal &&
                        <EmployeeArticleModal
                            {...props.EmployeeArticleInfo}
                            onEmployeeModalToggle={onEmployeeModalToggle}
                        />}
                </div>
            </div>
        </div>
    );
};

export default BlogDetailView;
global.BlogDetailView = BlogDetailView; 